import { FormattedMessage } from "react-intl";

import { Button } from "ui/Button/Button";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

type DiscardBatteryCountModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onClickPrimary: () => void;
  onClickSecondary: () => void;
};

export function DiscardBatteryCountModal({
  isOpen,
  onClose,
  onClickPrimary,
  onClickSecondary,
}: DiscardBatteryCountModalProps) {
  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Content maxW="295px" pt="s300" px="s200" pb="s200">
        <Modal.Body p="0">
          <HeaderS textAlign="center">
            <FormattedMessage id="pages.inventory.battery-management.modals.discard-battery-count.title" />
          </HeaderS>
          <BodyM mt="s100" textAlign="center" color="grey.700">
            <FormattedMessage id="pages.inventory.battery-management.modals.discard-battery-count.description" />
          </BodyM>
        </Modal.Body>
        <Modal.Footer p="0" mt="s200" flexDir="column" gap="s100">
          <Button onClick={onClickPrimary} variant="primary" size="lg" isFullWidth>
            <FormattedMessage id="pages.inventory.battery-management.modals.discard-battery-count.cta.primary" />
          </Button>
          <Button onClick={onClickSecondary} variant="secondary" size="lg" isFullWidth>
            <FormattedMessage id="pages.inventory.battery-management.modals.discard-battery-count.cta.secondary" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
